import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 100%;
`;

export const Frame = styled.iframe`
  width: 100%;
  border-radius: 4px;
  border: 1px solid #d1d5db;
`;
